import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../../shared/translate/translate.module';
import { AlertCommentDetailsComponent } from './alert-comment-details.component';

@NgModule({
  declarations: [AlertCommentDetailsComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule
  ],
  exports: [AlertCommentDetailsComponent]
})
export class AlertCommentDetailsModule { }
